<template>
  <div>
    <div v-if="show">
      <div class="dialog"  style="background-color: rgba(0, 0, 0, 0.3);">
        <slot></slot>
    </div>
    </div>
    
  </div>
</template>
<script>
export default {
  props:['show'],
  data() {
    return {

      };
   },
};
</script>

<style  lang="less" scoped>
.dialog{
  position: fixed;
  left: 0;
  top: 0;
  z-index:999999;
  height:100vh;
  width: 100vw;
  background-color:#000 ;
  display: grid;
  place-items: center;
  // opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/cModal.vue